import * as backdropActions from "./backdrop.actions";
import * as navigationActions from "./navigation.actions";

const alphaActions = { ...backdropActions, ...navigationActions };
export default alphaActions;
